import { Flex } from "@chakra-ui/react";
import { HistorySuccessRatePieChart } from "../../dashboard/charts/v2/HistoryPieChart";
import BasePageTitleContainer from "../../form/BasePageTitleContainer";
import { useParams } from "react-router-dom";
import { IntegrationItem } from "../../../models/integration-item.model";
import { useSelector } from "react-redux";
import { RootState } from "../../../store";

interface metric {
  totalDuration: number;
  averageDuration: number;
}

export const RunAttemptsSuccessCard = ({
  metric,
  runs,
}: {
  metric: metric;
  runs: IntegrationItem[];
}) => {
  const RUN_DEVIATION_THRESHOLD = 0.5;

  const runDurationAcceptable = (duration: number) => {
    const deviation = Math.abs(duration - metric.averageDuration);
    const deviationPercentage = deviation / metric.averageDuration;
    return deviationPercentage < RUN_DEVIATION_THRESHOLD;
  };

  const { id } = useParams();

  const { workflows } = useSelector((state: RootState) => state.sidebar);

  return (
    <BasePageTitleContainer
      mt="0px"
      padding="24px"
      height="100%"
      width="100%"
      display="flex"
      flexDirection="column"
      flexGrow={1}
      maxWidth="35%"
    >
      <div className="flex flex-col h-full w-full min-h-0">
        <div className="shrink-0 mb-3">
          <div className="text-[11px] font-medium uppercase tracking-[0.12em] text-muted-foreground mb-1">
            Success rate
          </div>
          <div className="text-sm font-medium text-foreground mb-1">
            {workflows?.find((x) => +x.id === +id)?.description}
          </div>
          <div className="text-xs text-muted-foreground">
            {runs.length} most recent run attempts
          </div>
        </div>
        <div className="flex flex-1 min-h-0 w-full items-center gap-4">
          <div className="flex-1 min-w-0 h-full flex items-center justify-center">
            <HistorySuccessRatePieChart data={runs} />
          </div>
          <Flex flexDir="column" gap="8px" className="shrink-0 pr-2">
            <Flex flexDir="row" gap="8px" alignItems="center">
              <div className="bg-[#3D9B6E] h-2.5 w-2.5 shrink-0"></div>
              <div className="font-normal text-sm w-[110px] text-muted-foreground">
                Success
              </div>
              <div className="font-medium text-sm font-mono">
                {runs?.filter((x) => x.conclusion === "success").length}
              </div>
            </Flex>
            <Flex flexDir="row" gap="8px" alignItems="center">
              <div className="bg-[#C45C5C] h-2.5 w-2.5 shrink-0"></div>
              <div className="font-normal text-sm w-[110px] text-muted-foreground">
                Failed
              </div>
              <div className="font-medium text-sm font-mono">
                {runs?.filter((x) => x.conclusion !== "success").length}
              </div>
            </Flex>
            <Flex flexDir="row" gap="8px" alignItems="start">
              <div className="bg-[#D4A054] h-2.5 w-2.5 mt-1.5 shrink-0"></div>
              <div className="font-normal text-sm w-[110px] leading-snug text-muted-foreground">
                Requiring attention
              </div>
              <div className="font-medium text-sm font-mono">
                {runs?.filter((x) => !runDurationAcceptable(x.duration)).length}
              </div>
            </Flex>
          </Flex>
        </div>
      </div>
    </BasePageTitleContainer>
  );
};
